var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrialWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "0c70.686 0 134.69 28.658 181.016 74.983C483.342 121.309 512 185.314 512 256c0 70.685-28.658 134.69-74.984 181.016C390.69 483.341 326.686 512 256 512c-70.686 0-134.69-28.659-181.016-74.984C28.658 390.69 0 326.685 0 256c0-70.686 28.658-134.691 74.984-181.017C121.31 28.658 185.314 0 256 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#faad14",
    d: "M256 29.463c125.114 0 226.536 101.423 226.536 226.537S381.114 482.536 256 482.536 29.464 381.114 29.464 256 130.886 29.463 256 29.463z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M256 341.491c14.453 0 26.168 11.718 26.168 26.172 0 14.453-11.715 26.167-26.168 26.167s-26.171-11.714-26.171-26.167c0-14.454 11.718-26.172 26.171-26.172zm19.55-39.21c-.88 22.062-38.246 22.092-39.1-.008-3.778-37.803-13.443-127.552-13.135-163.073.311-10.946 9.383-17.427 20.989-19.899 3.578-.764 7.513-1.135 11.477-1.132 3.986.008 7.932.401 11.514 1.166 11.988 2.554 21.401 9.301 21.398 20.444l-.045 1.117-13.098 161.385z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialWarning);
export default __webpack_public_path__ + "static/media/trial-warning.46db7a8909e0ef57b9e3e90ce01e7e83.svg";
export { ForwardRef as ReactComponent };